import classes from "./Box.module.css";
import { getCategoryInfos } from "../Map/utils";

const Box = ({ typeId, className, onClick, children }) => {
  return (
    <section
      className={[classes.box, className].join(" ")}
      style={{ backgroundColor: getCategoryInfos(typeId)?.bgColor }}
      onClick={() => onClick && onClick()}
    >
      {children}
    </section>
  );
};

export default Box;
